{
  "name": "@uppy/remote-sources",
  "description": "Uppy plugin that includes all remote sources that Uppy+Companion offer, like Google Drive, Dropbox, Box, Unsplash, Url etc",
  "version": "4.0.0",
  "license": "MIT",
  "type": "module",
  "sideEffects": false,
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build",
    "test": "vitest run --silent='passed-only'"
  },
  "keywords": [
    "file uploader",
    "google-drive",
    "facebook",
    "dropbox",
    "onedrive",
    "zoom",
    "unsplash",
    "box",
    "url"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@uppy/box": "workspace:^",
    "@uppy/dashboard": "workspace:^",
    "@uppy/dropbox": "workspace:^",
    "@uppy/facebook": "workspace:^",
    "@uppy/google-drive": "workspace:^",
    "@uppy/onedrive": "workspace:^",
    "@uppy/unsplash": "workspace:^",
    "@uppy/url": "workspace:^",
    "@uppy/zoom": "workspace:^"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "publishConfig": {
    "access": "public"
  },
  "devDependencies": {
    "@uppy/core": "workspace:^",
    "@vitest/browser-playwright": "^4.1.6",
    "playwright": "1.61.1",
    "typescript": "^6.0.3",
    "vitest": "^4.1.6"
  }
}
